export default __webpack_public_path__ + "static/media/logo-text.e0bfc0e8.jpg";